import { render, staticRenderFns } from "./AppGlobalEventSourceListeners.vue?vue&type=template&id=24329642&scoped=true"
import script from "./AppGlobalEventSourceListeners.vue?vue&type=script&lang=js"
export * from "./AppGlobalEventSourceListeners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24329642",
  null
  
)

export default component.exports